export const selectPendingFees = state =>
  state.apps['employer-experience']?.pendingFees?.feesList;
